import DragItem from "../../ddTxtImg/model/DragItem";
import DropItem from "../../ddTxtImg/model/DropItem";
import WordOnImgDropItemUI from "../ui/WordOnImgDropItemUI";
import WordOnImgDropItem from "./WordOnImgDropItem";


class WordOnImgDropItemContainer {


    constructor() {
        this.mainImgsrc = "";
        this.mainTxt = "";
        this.hasExternalUrl = false;
        this.hasOnlyDropItems = false;

        //this.showImg = true
        this.showImg = true

        this.dropItemList = [];
        // this.dropItemStyleIndex = 0;
        this.styleIndex = 0
        this.initStyleArr();
        this.selectedStyle = this.styleArr[this.styleIndex]
    }

    initStyleArr = () => {
        this.styleArr = []
    }


    addDropItem = () => {
        let dropItem = new WordOnImgDropItem()
        this.dropItemList.push(dropItem)
    }

    getAsJson = () => {
        let obj = {}
        obj.mainImgsrc = this.mainImgsrc
        obj.mainTxt = this.mainTxt
        obj.hasExternalUrl = this.hasExternalUrl
        obj.dropItemList = []
        obj.hasOnlyDropItems=this.hasOnlyDropItems

        for (let i = 0; i < this.dropItemList.length; i++) {

            obj.dropItemList.push(this.dropItemList[i].getAsJson())
        }

        return obj
    }


    initFromJson = (obj) => {
        this.selectedStyle = obj.selectedStyle
        this.mainImgsrc = obj.mainImgsrc
        this.mainTxt = obj.mainTxt
        this.showImg = this.mainTxt == ""
        this.hasExternalUrl = obj.hasExternalUrl
        if (obj.hasOnlyDropItems)
            this.hasOnlyDropItems = obj.hasOnlyDropItems
        if (obj.dropItemList != null) {

            for (let i = 0; i < obj.dropItemList.length; i++) {
                let dropItem = new WordOnImgDropItem()
                dropItem.initFromJson(obj.dropItemList[i])
                this.dropItemList.push(dropItem)
            }
        }
    }


    getReportAsJson = () => {
        let obj = {}


        return this.getAsJson()
    }


    initReportFromJson = (obj) => {
        this.initFromJson(obj)
    }

    initFromJsonTest4You = (obj, dragItemList) => {
        
        this.hasOnlyDropItems = true
        let dropItemContainer = JSON.parse(obj)
        let correctAnswers = []
        for (var key of Object.keys(dropItemContainer)) {
            let dragItem = new DragItem()
            dragItemList.map(function (item, index) {
                if (item.dragIndex == parseInt(key) - 1) {
                    dragItem = item
                    correctAnswers.push(dragItem)
                }
            })
        }
        for (var key of Object.keys(dropItemContainer)) {
            let dropItem = new WordOnImgDropItem();
            dropItem.dropType = dragItemList[0].dragItemType
            dropItem.dragList = correctAnswers
            this.dropItemList.push(dropItem)
        }
    }

}


export default WordOnImgDropItemContainer